import {IBackendCaller} from "./backendCaller";

const personTypesURL = "/api/personTypes";

export interface PersonType {
  id: string;
  name: string;
}

/**
 * Fetches the list of person types (Independent / Serviced) from the BFF.
 *
 * The BFF (see PersonTypesController) proxies GET /user/v1/personTypes on the
 * User API and coerces the numeric int64 id to a string so precision is not
 * lost in JavaScript.
 */
export interface IPersonTypeService {
  getPersonTypes: (abortController?: AbortController) => Promise<PersonType[]>;
}

export class PersonTypeService implements IPersonTypeService {
  private readonly backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  getPersonTypes = async (
    abortController?: AbortController
  ): Promise<PersonType[]> => {
    return await this.backendCaller.callApi(
      "GET",
      personTypesURL,
      null,
      null,
      false,
      abortController
    );
  };
}
